import { deleteApiRequest } from 'api/index';
import { IDeleteCalendarPlanPeriodParams } from 'types/calendarPlan';

export const deleteCalendarPlanPeriod = (params: IDeleteCalendarPlanPeriodParams): Promise<number> => {
    return deleteApiRequest(`/period/bulk-delete/`, params);
};
